"use strict";

require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _constellation = require("@zillow/constellation");
var S = _interopRequireWildcard(require("./styles"));
var _analytics = require("../analytics");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Misc / utils
var InputAndSlider = function InputAndSlider(_ref) {
  var title = _ref.title,
    min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    value = _ref.value,
    leftAdornment = _ref.leftAdornment,
    rightAdornment = _ref.rightAdornment,
    onChange = _ref.onChange,
    tooltipText = _ref.tooltipText;
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    onChange(value);
    (0, _analytics.trackEvent)({
      label: title,
      value: value
    });
  };
  var adornedInputProps = {
    input: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Input, {
      size: "sm",
      fluid: false,
      value: value,
      onChange: handleChange
    }),
    style: {
      width: '150px'
    }
  };
  if (leftAdornment) {
    adornedInputProps.leftAdornment = /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Adornment, {
      children: leftAdornment
    });
  }
  if (rightAdornment) {
    adornedInputProps.rightAdornment = /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Adornment, {
      children: rightAdornment
    });
  }
  var tooltip = /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Tooltip, {
    body: /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Paragraph, {
      children: tooltipText
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(S.SliderInputContainer, {
    paddingY: "md",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Flex, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "md",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_constellation.Text, {
        fontType: "bodySmallHeading",
        as: "h4",
        children: [title, ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.TooltipPopper, {
          triggered: tooltip
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.AdornedInput, _objectSpread({}, adornedInputProps))]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_constellation.Range, {
      min: min,
      max: max,
      value: value,
      onChange: handleChange,
      step: step
    })]
  });
};
var _default = exports["default"] = InputAndSlider;